import BaseStore from '@/store/base-store'
import http from '@/services/http.service'

const options = {
  state: {
    metGoals: {},
    globalGoals: []
  },
  getters: {
    metGoals (state) {
      return state.metGoals
    },
    globalGoals (state) {
      return state.metGoals
    }
  },
  mutations: {
    metGoals (state, payload) {
      state.metGoals = payload
    },
    globalGoals (state, payload) {
      state.globalGoals = payload
    }
  },
  actions: {
    metGoals ({commit}, payload) {
      return http.get('met-goals/territorial', {params: payload}).then(response => {
        commit('metGoals', response.data)
        return response
      })
    },
    globalGoals ({commit}, payload) {
      return http.get('global-goals', {params: payload}).then(response => {
        commit('globalGoals', response.data)
        return response
      })
    }
  }
}
let myGoals = new BaseStore('territorial-goals', options)
export default myGoals



// WEBPACK FOOTER //
// ./src/store/modules/zone-goals.store.js